import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'elevated' | 'outlined' | 'ghost';
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const variantClasses = {
  default: 'bg-card border border-border',
  elevated: 'bg-card-elevated shadow-lg border border-border-subtle',
  outlined: 'bg-transparent border border-border',
  ghost: 'bg-transparent',
};

const paddingClasses = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

export function Card({
  children,
  className = '',
  variant = 'default',
  hover = false,
  padding = 'md',
}: CardProps) {
  return (
    <div
      className={`
        rounded-xl
        transition-all duration-300 ease-out
        ${variantClasses[variant]}
        ${paddingClasses[padding]}
        ${hover ? 'hover:border-accent-mint/30 hover:shadow-glow-mint/10 hover:-translate-y-0.5' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
}

export default Card;
